import React from "react";

import { Link, useHistory } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import { useTranslation } from "react-i18next"; // ✅ import
/// Image
import profile from "../../../images/profile/pic1.jpg";
import avatar from "../../../images/avatar/1.jpg";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "../../../context/auth/auth.context";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
const Header = ({ onNote }) => {
  const { t } = useTranslation(); // ✅ hook
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
      ? filterName.filter((f) => f !== "ui")
      : filterName.includes("uc")
        ? filterName.filter((f) => f !== "uc")
        : filterName.includes("basic")
          ? filterName.filter((f) => f !== "basic")
          : filterName.includes("jquery")
            ? filterName.filter((f) => f !== "jquery")
            : filterName.includes("table")
              ? filterName.filter((f) => f !== "table")
              : filterName.includes("page")
                ? filterName.filter((f) => f !== "page")
                : filterName.includes("email")
                  ? filterName.filter((f) => f !== "email")
                  : filterName.includes("ecom")
                    ? filterName.filter((f) => f !== "ecom")
                    : filterName.includes("chart")
                      ? filterName.filter((f) => f !== "chart")
                      : filterName.includes("editor")
                        ? filterName.filter((f) => f !== "editor")
                        : filterName;
  // console.log(finalName.join(" "));
  const { logout } = useAuth();
  const history = useHistory();
  const handleLogout = () => {
    logout(); // clear user from context
    localStorage.removeItem("jwt"); // optional, clear JWT too
    history.push("/page-login"); // redirect to login
  };


  return (
    <div className="header bg-white shadow-sm py-3">
      <div className="container-fluid">
        <nav className="navbar d-flex align-items-center justify-content-between">


          {/* LEFT SECTION: Empty for balance or future icons */}
          <div style={{ width: "140px" }}></div>

          {/* CENTER SECTION: Title */}
          <div
            className="text-center flex-grow-1"
            style={{
              fontFamily: "'Cairo', sans-serif",
              fontWeight: 800,
              fontSize: "1.2rem",
              color: "#B0000D",
              textAlign: "center",
              letterSpacing: "0.5px",
            }}
          >
            AI AIDEA Blood Management Dashboard – Vacsera Performance Insights
          </div>



          {/* RIGHT SECTION: Language + Logout */}
          <div className="d-flex align-items-center gap-3">
            <LanguageSwitcher />
            <button
              onClick={handleLogout}
              className="btn btn-outline-danger btn-sm d-flex align-items-center"
              style={{ borderRadius: "8px", fontFamily: "'Cairo', sans-serif" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={18}
                height={18}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="me-2"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1={21} y1={12} x2={9} y2={12} />
              </svg>
              {t("Logout")}
            </button>
          </div>
        </nav>
      </div>
    </div>
  );

};

export default Header;
